import { adminLoginAPI } from "./api"

export function adminLogin(data) {
    return new Promise((resolve, reject) => {
        adminLoginAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}